import PageHeader from '../includes/PageHeader';
import locale from 'date-fns/locale/en-US';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React, { useEffect, useState } from 'react';
import {
    Button,
    Typography,
    TextField,
    CircularProgress
} from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';

import { format } from 'date-fns/esm';
import showMessage from '../../../helpers/showMessage';
import axios from 'axios';
import { LOCAL_STORAGE_USER } from '../../../configs/constants';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../../configs/messages';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import { ROUTES_LIST } from '../../../helpers/routesList';

import { differenceInCalendarDays } from 'date-fns';



export function ForeignChannel() {
    const [initialData, setInitialData] = useState({
        startDate: null,
        endDate: null,
    });

    const [tv, setTv] = React.useState('');
    const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
    const token = user.accessToken;
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const [loading, setLoading] = useState(false); 
    const [errors, setErrors] = useState({});
    const [isSubmitDisabled, setIsSubmitDisabled ] = useState(true);


    useEffect(() => {
        const validateAndUpdate = () => {
            if (initialData.startDate && initialData.endDate) {
                if (tv) {
                    const tempErrors = validate();
                    const hasErrors = Object.values(tempErrors).some(error => error);
    
                    if (hasErrors) {
                        setIsSubmitDisabled(true);
                    } else {
                        setIsSubmitDisabled(false);
                    }
                } else {
                    setIsSubmitDisabled(true);
                }
            } else {
                setIsSubmitDisabled(true);
            }
        };
    
        validateAndUpdate();
    }, [initialData.startDate, initialData.endDate, tv]);


    const handleDateChange = (date, name) => {
        setInitialData((prevData) => ({
            ...prevData,
            [name]: date,
        }));
    };

    const handleChange = (event) => {
        setTv(event.target.value);
      };

    const handleSubmitNHK = async(e) => {
        e.preventDefault();
        setLoading(true);  

        const formattedStartDate = format(new Date(initialData.startDate), 'yyyy/MM/dd');
        const formattedEndDate = format(new Date(initialData.endDate), 'yyyy/MM/dd');

        const query = new URLSearchParams({
            startDate: formattedStartDate,
            endDate: formattedEndDate
        }).toString();

        await axios.get( `${ process.env.REACT_APP_CMS_API_PATH}/integration/${tv}?${query}`,{
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(() => {
                showMessage(SUCCESS_MESSAGES.DOWNLOADED, enqueueSnackbar);
                history.push(ROUTES_LIST.foreignChannelList);
        })
        .catch((error) => {
            console.error("error",error);
            showMessage(
                error.response?.data?.message
                    ? error.response.data.message
                    : ERROR_MESSAGES.REQUEST_FAIL,
                enqueueSnackbar,
                'error',
            );
        }).finally(() => {
            setLoading(false);
        });
    }

    const validate = () => {
        let tempErrors = { ...errors };
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;

        if ('startDate' in initialData && 'endDate' in initialData) {
            tempErrors.endDate = initialData.endDate ? '' : requiredMessage;

            tempErrors.startDate = initialData.startDate ? '' : requiredMessage;

            let diff = differenceInCalendarDays(
                new Date(initialData.endDate),
                new Date(initialData.startDate),
            );

            if(diff !== 6){
                tempErrors.endDate = 'error';
                tempErrors.startDate = 'error';
                showMessage(
                    ERROR_MESSAGES.NOT_MATCHED_DATE_RANGE,
                    enqueueSnackbar,
                    'error',
                );
            }
        }

        setErrors({
            ...tempErrors,
        });

        return tempErrors;
    };


    return (
        <>
            <div>
                <PageHeader
                    pageName={
                        `Гадаад сувгийн хөтөлбөр татах`
                    }
                    showAddNew={false}
                />
            </div>
            <div style={{display: 'flex', flexDirection: 'column', gap: '25px'}}>
                <div style={{marginLeft: '10px'}}>
                    <p>Хөтөлбөрийн эхлэх болон дуусах хугацааг сонгох</p>
                    <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        locale={locale}
                    >
                        <DesktopDatePicker
                            label="Эхлэх өдөр"
                            inputFormat="yyyy/MM/dd"
                            mask="____/__/__"
                            value={initialData.startDate}
                            onChange={(newValue) => {
                                handleDateChange(
                                    newValue,
                                    'startDate',
                                );
                            }}
                            renderInput={(params) => (
                                <TextField {...params} />
                            )}
                            disabled={loading}
                        />
                        <RemoveIcon
                            style={{ padding: '15px 5px' }}
                        />
                        <DesktopDatePicker
                            label="Дуусах өдөр"
                            inputFormat="yyyy/MM/dd"
                            mask="____/__/__"
                            value={initialData.endDate}
                            onChange={(newValue) => {
                                handleDateChange(
                                    newValue,
                                    'endDate',
                                );
                            }}
                            renderInput={(params) => (
                                <TextField {...params} />
                            )}
                            disabled={loading}
                        />        
                    </LocalizationProvider>
                </div>
                <div style={{marginLeft: '10px'}}>
                    <p>ТВ суваг сонгох</p>
                    <Box sx={{ minWidth: '200px', maxWidth: '550px' }}>
                        <FormControl fullWidth disabled={loading}>
                            <InputLabel id="demo-simple-select-label">ТВ суваг</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={tv}
                                label="TV"
                                onChange={handleChange}
                            >
                                <MenuItem value={"nhk"}>NHK</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </div>
                <Button
                        color="success"
                        style={{ marginLeft: '10px', width: '150px', height: '50px'}}
                        type="submit"
                        variant="outlined"
                        onClick={handleSubmitNHK}
                        disabled={isSubmitDisabled}
                >
                    {loading ? (
                        <CircularProgress size={24} color="inherit" />
                    ) : (
                        <Typography style={{ marginLeft: '10px' }}>
                            Татах
                        </Typography>
                    )}
                </Button>
            </div>
        </>
    );
}